import { Component, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Department } from "@enums/department.enum";
import { MaterialShape } from "@enums/materialShape.enum";
import { MaterialType } from "@enums/materialType.enum";
import { PartRelationshipType } from "@enums/partRelationshipType.enum";
import { PurchaseTypeEnum } from "@enums/purchaseType.enum";
import { QualityControlCheckType } from "@enums/qualityControlCheckType.enum";
import { environment } from "@environments/environment";
import { CheckGroupPermissions } from "@helpers/checkGroupPermissions";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { densityForMaterialType } from "@helpers/materialTypeDensity";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { ClientContact } from "@interfaces/clientContact.interface";
import { CreateSalesOrderFromPart } from "@interfaces/createSalesOrderFromPart.interface";
import { DeliveryNoteForPart } from "@interfaces/deliveryNoteForPart.interface";
import { ChangeWorkOrderQuantity } from "@interfaces/dto/changeWorkOrderQuantity.interface";
import { ResolveQuarantineDto } from "@interfaces/dto/resolveQuarantineDto.interface";
import { InvoiceForPart } from "@interfaces/invoiceForPart.interface";
import { Client } from "@interfaces/models/client.interface";
import { Machine } from "@interfaces/models/machine.interface";
import { OutsideProcessContract } from "@interfaces/models/outsideProcessContract.interface";
import { OutsourcedSpecification } from "@interfaces/models/outsourcedSpecification.interface";
import { Packaging } from "@interfaces/models/packaging.interface";
import { Part } from "@interfaces/models/part.interface";
import { PaymentTerm } from "@interfaces/models/paymentTerm.interface";
import { ProductionTool } from "@interfaces/models/productionTool.interface";
import { ProductionToolPart } from "@interfaces/models/productionToolPart.interface";
import { QuarantinedPart } from "@interfaces/models/quarantinedPart.interface";
import { Supplier } from "@interfaces/models/supplier.interface";
import { PartFileLink } from "@interfaces/partFileLink.interface";
import { PartProcessRouter } from "@interfaces/partProcessRouter.interface";
import { PartPurchasableItemRequired } from "@interfaces/partPurchasableItemRequired.interface";
import { PartRelationship } from "@interfaces/partRelationship.interface";
import { PartSchedule, PartScheduleEntry } from "@interfaces/partSchedule.interface";
import { Process } from "@interfaces/process.interface";
import { Project } from "@interfaces/project.interface";
import { PurchasableItem } from "@interfaces/purchasableItem.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { AppSettingsService } from "@services/appSettings.service";
import { ClientService } from "@services/client.service";
import { ClientContactService } from "@services/clientContact.service";
import { DeliveryNoteService } from "@services/deliveryNote.service";
import { EdiOrderService } from "@services/ediOrder.service";
import { FileService } from "@services/file.service";
import { InvoiceService } from "@services/invoice.service";
import { MachineService } from "@services/machine.service";
import { OpsActionAuditService } from "@services/opsActionAudit.service";
import { OutsideProcessContractService } from "@services/outsideProcessContract.service";
import { OutsourcedSpecificationService } from "@services/outsourcedSpecification.service";
import { PackagingService } from "@services/packaging.service";
import { PartService } from "@services/part.service";
import { PartRelationshipService } from "@services/partRelationship.service";
import { PaymentTermService } from "@services/paymentTerm.service";
import { ProcessService } from "@services/process.service";
import { ProcessMachineService } from "@services/processMachine.service";
import { ProductionToolService } from "@services/productionTool.service";
import { ProductionToolPartService } from "@services/productionToolPart.service";
import { ProjectService } from "@services/project.service";
import { PurchasableItemService } from "@services/purchasableItem.service";
import { QuarantinedPartService } from "@services/quarantinedPart.service";
import { SalesOrderService } from "@services/salesOrder.service";
import { SupplierService } from "@services/supplier.service";
import { UserProfileService } from "@services/userProfile.service";
import { WorkOrderService } from "@services/workOrder.service";
import { ToastService } from "angular-toastify";
import { DxDataGridComponent } from "devextreme-angular";
import { Guid } from "guid-typescript";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "parts-id",
	styleUrls: ["parts-id.css"],
	templateUrl: "parts-id.html"
})
export class PartsIdAdminComponent {
	@ViewChild("consumablesGridContainer", { static: false }) consumablesGrid!: DxDataGridComponent;
	@ViewChild("fixingsGridContainer", { static: false }) fixingsGrid!: DxDataGridComponent;
	@ViewChild("routingGridContainer", { static: false }) routingGrid!: DxDataGridComponent;
	allowRouterChanges = false;
	cadFiles: PartFileLink[] = [];
	changes: any = [];
	clients: Client[] = [];
	consumablePurchasableItems: PurchasableItem[] = [];
	consumablesRequired: PartPurchasableItemRequired[] = [];
	contact: ClientContact = new ClientContact();
	contacts: ClientContact[] = [];
	createEnabled = true;
	deliveryNotesForPart: DeliveryNoteForPart[] = [];
	dropDownFirewallMachines: Machine[] = [];
	dropDownMachines: Machine[] = [];
	editEnabled = true;
	editRowKey: any = null;
	filteredPurchasableItems: PurchasableItem[] = [];
	fixingPurchasableItems: PurchasableItem[] = [];
	fixingsRequired: PartPurchasableItemRequired[] = [];
	hasCheckedSuperAdminStatus = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	inspectPartVisible = false;
	invoicesForPart: InvoiceForPart[] = [];
	isEnhancedWorkOrderManagement = false;
	isProductionManagement = false;
	isQualityManagement = false;
	isSuperAdmin = false;
	item: Part = new Part();
	itemId = 0;
	itemType = "Part";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	machines: Machine[] = [];
	masterPartId = 0;
	masterParts: PartRelationship[] = [];
	materialPurchasableItems: PurchasableItem[] = [];
	materialShapes: any;
	materialTypes: any;
	opsActionAudits: any;
	outsideProcessContracts: OutsideProcessContract[] = [];
	outsourcedSpecifications: OutsourcedSpecification[] = [];
	packaging: Packaging[] = [];
	packagingImageStyle = "";
	packagingImageStyleExternal = "";
	partRelationships: any;
	partSchedule: PartSchedule | null = null;
	parts: Part[] = [];
	paymentTerms: PaymentTerm[] = [];
	people: UserProfile[] = [];
	popupAddButtonOptions: any;
	popupAmountQuarantined = 0;
	popupChangeWorkOrderQuantity: ChangeWorkOrderQuantity = new ChangeWorkOrderQuantity();
	popupClient: Client = new Client();
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupContact: ClientContact = new ClientContact();
	popupCreateSalesOrderFromPart: CreateSalesOrderFromPart = new CreateSalesOrderFromPart();
	popupOutsideProcessContract: OutsideProcessContract = new OutsideProcessContract();
	popupPartToCopyRouterFrom: Part = new Part();
	popupProductionToolPart: ProductionToolPart = new ProductionToolPart();
	popupProject: Project = new Project();
	popupPurchasableItem: PurchasableItem = new PurchasableItem();
	popupRelationship: PartRelationship = new PartRelationship();
	popupResolveQuarantine: ResolveQuarantineDto = new ResolveQuarantineDto();
	popupSupplier: Supplier = new Supplier();
	popupSupportingDocument: PartFileLink = new PartFileLink();
	popupTitle = "";
	popupVisible = false;
	processRouters: PartProcessRouter[] = [];
	processes: Process[] = [];
	productionToolParts: ProductionToolPart[] = [];
	productionTools: ProductionTool[] = [];
	projects: Project[] = [];
	purchasableItems: PurchasableItem[] = [];
	purchaseTypes: any;
	qualityControlCheckTypes: any;
	quantityRequired = 1;
	quarantinedParts: QuarantinedPart[] = [];
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	// Schedule (Outbound tab): forward EDI demand as a calendar.
	scheduleAgenda: { entries: PartScheduleEntry[]; label: string }[] = [];
	scheduleExpanded = false;
	scheduleMap: Record<string, PartScheduleEntry> = {};
	scheduleMax = 0;
	scheduleMonth: Date = new Date();
	scheduleView = "month"; // "month" | "timeline" | "list"
	scheduleWeeks: { date: Date; entry: PartScheduleEntry | null; inMonth: boolean }[][] = [];
	screenMode = "";
	stpBackgroundIndex = 0;
	stpCamera: any = null;
	stpColourMode = 0;
	stpControls: any = null;
	stpDimensions = "";
	stpExploded = false;
	stpInitialCameraPos: any = null;
	stpInitialTarget: any = null;
	stpMeasureMode = false;
	stpMeasurePoint1: any = null;
	stpMeasureResult = "";
	stpMeshCenters: any[] = [];
	stpMeshes: any[] = [];
	stpOriginalColours: number[] = [];
	stpRenderer: any = null;
	stpScene: any = null;
	stpSurfaceArea = "";
	stpVolume = "";
	stpWireframe = false;
	subParts: PartRelationship[] = [];
	suppliers: Supplier[] = [];
	supportingDocumentButtonOptions = {
		onClick: () => this.addNewSupportingDocumentPopup(),
		text: "Add Document",
		type: "default",
		useSubmitBehavior: false
	}
	supportingDocuments: PartFileLink[] = [];
	technicalDrawings: PartFileLink[] = [];
	thicknesses: number[] = environment.build.thicknesses;
	tileImageStyle = "";
	title: string = "View " + this.itemType;
	workOrderStageSummary: any;
	workOrders: any = [];

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private appSettingsService: AppSettingsService, private clientContactService: ClientContactService, private clientService: ClientService, private fileService: FileService, private outsourcedSpecificationService: OutsourcedSpecificationService, private paymentTermsService: PaymentTermService, private machineService: MachineService, private opsActionAuditService: OpsActionAuditService, private outsideProcessContractService: OutsideProcessContractService, private packagingService: PackagingService, private productionToolService: ProductionToolService, private productionToolPartService: ProductionToolPartService, private projectService: ProjectService, private purchasableItemService: PurchasableItemService, private itemService: PartService, private partRelationshipService: PartRelationshipService, private processService: ProcessService, private processMachineService: ProcessMachineService, private quarantinedPartService: QuarantinedPartService, private salesOrderService: SalesOrderService, private supplierService: SupplierService, private userProfileService: UserProfileService, private workOrderService: WorkOrderService, private deliveryNoteService: DeliveryNoteService, private invoiceService: InvoiceService, private ediOrderService: EdiOrderService) {
		this.getClients();
		this.getMachines();
		this.getPackaging();
		this.getParts();
		this.getPaymentTerms();
		this.getPeople();
		this.getProcesses();
		this.getProductionTools();
		this.getProjects();
		this.getPurchasableItems();
		this.getSuppliers();

		this.isEnhancedWorkOrderManagement = CheckGroupPermissions(appSettingsService, "Enhanced Work Order Management");
		this.isProductionManagement = CheckGroupPermissions(appSettingsService, "Production Management");
		this.isQualityManagement = CheckGroupPermissions(appSettingsService, "Quality Management");
		this.isSuperAdmin = CheckGroupPermissions(appSettingsService, "Super Admin");
		this.materialShapes = GetPropertiesFromEnum(MaterialShape);
		this.materialTypes = GetPropertiesFromEnum(MaterialType);
		this.qualityControlCheckTypes = GetPropertiesFromEnum(QualityControlCheckType);
		this.partRelationships = GetPropertiesFromEnum(PartRelationshipType);
		this.purchaseTypes = GetPropertiesFromEnum(PurchaseTypeEnum);

		this.route.params.subscribe((params) => {
			if (params.id != "create") {
				if (params.id.split("_").length > 1) {
					this.itemId = params.id.split("_")[0];
					this.getItem(this.itemId, "edit", false);
					this.toastService.warn("You are now editing!");
				} else {
					this.itemId = params.id;
					const hideButtons = document.referrer.includes("edi-orders");
					this.getItem(this.itemId, "view", false);
					this.readOnly = hideButtons;
				}
			} else {
				this.create();
			}
		});

		this.changeWorkOrderQuantityPopup = this.changeWorkOrderQuantityPopup.bind(this);
		this.deleteCadFileLink = this.deleteCadFileLink.bind(this);
		this.deletePartRelationship = this.deletePartRelationship.bind(this);
		this.deleteProductionToolPart = this.deleteProductionToolPart.bind(this);
		this.deleteSupportingDocumentLink = this.deleteSupportingDocumentLink.bind(this);
		this.deleteTechnicalDrawingLink = this.deleteTechnicalDrawingLink.bind(this);
		this.downloadFileLink = this.downloadFileLink.bind(this);
		this.editOutsideProcessContractPopup = this.editOutsideProcessContractPopup.bind(this);
		this.editPartRelationshipChildPopup = this.editPartRelationshipChildPopup.bind(this);
		this.editPartRelationshipMasterPopup = this.editPartRelationshipMasterPopup.bind(this);
		this.editProductionToolPartPopup = this.editProductionToolPartPopup.bind(this);
		this.editWorkOrder = this.editWorkOrder.bind(this);
		this.generateAndDownloadWorkOrderMasterLabelPDF = this.generateAndDownloadWorkOrderMasterLabelPDF.bind(this);
		this.isResolveAvailableForRow = this.isResolveAvailableForRow.bind(this);
		this.resolveQuarantinePopup = this.resolveQuarantinePopup.bind(this);
		this.updateRouterOrder = this.updateRouterOrder.bind(this);
		this.updateRouterNumbers = this.updateRouterNumbers.bind(this);
		this.uploadPackingImage = this.uploadPackingImage.bind(this);
		this.uploadPackingImageExternal = this.uploadPackingImageExternal.bind(this);
		this.uploadCadFile = this.uploadCadFile.bind(this);
		this.uploadSupportingDocument = this.uploadSupportingDocument.bind(this);
		this.uploadTechnicalDrawing = this.uploadTechnicalDrawing.bind(this);
		this.uploadTileImage = this.uploadTileImage.bind(this);
		this.viewMasterPart = this.viewMasterPart.bind(this);
		this.viewProductionTool = this.viewProductionTool.bind(this);
		this.viewSubPart = this.viewSubPart.bind(this);
		this.viewWorkOrder = this.viewWorkOrder.bind(this);
		this.viewDeliveryNote = this.viewDeliveryNote.bind(this);
		this.downloadDeliveryNote = this.downloadDeliveryNote.bind(this);
		this.viewInvoice = this.viewInvoice.bind(this);
		this.downloadInvoice = this.downloadInvoice.bind(this);
	}

	addNewClient() {
		this.clientService.createSingle(this.popupClient)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.popupClient = new Client();
					this.getClients(true);
				},
				(err: any) => console.log(err)
			);
	}

	addNewClientPopup() {
		this.popupTitle = "Add New Client";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewClient(), text: "Add Client" };
	}

	addNewContact() {
		this.clientContactService.createSingle(this.popupContact)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.getContacts(this.item.clientId, true);
				},
				(err: any) => {
					this.toastService.error("Could not add client contact. Please check the details are valid and this contact does not already exist.");
					console.log(err);
				}
			);
	}

	addNewContactPopup() {
		this.popupContact = new ClientContact();
		this.popupContact.clientId = this.item.clientId;
		this.popupTitle = "Add New Contact";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewContact(), text: "Add Contact" };
	}

	addNewOutsideProcessContract() {
		this.outsideProcessContractService.createSingle(this.popupOutsideProcessContract)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.getOutsideProcessContracts(this.item.id);
				},
				(err: any) => {
					this.toastService.error("Could not add contract. Please check the details are valid and there isn't already an active contract for this stage.");
					console.log(err);
				}
			);
	}

	addNewOutsideProcessContractPopup() {
		this.popupOutsideProcessContract = new OutsideProcessContract();
		this.popupOutsideProcessContract.partId = this.item.id;
		this.popupOutsideProcessContract.cumulativeQuantity = 0;
		this.popupOutsideProcessContract.isActive = false;
		this.popupTitle = "Add New Outside Process";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewOutsideProcessContract(), text: "Add Contract" };
	}

	addNewProductionToolPart() {
		this.productionToolPartService.createSingle(this.popupProductionToolPart)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.getProductionToolParts();
				},
				(err: any) => {
					this.toastService.error("Could not add production tool. Please check the details are valid and you have not already specified a tool for this router stage.");
					console.log(err);
				}
			);
	}

	addNewProductionToolPartPopup() {
		this.popupProductionToolPart = new ProductionToolPart();
		this.popupProductionToolPart.partId = this.item.id;
		this.popupTitle = "Add New Tool";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewProductionToolPart(), text: "Add Tool" };
	}

	addNewProject() {
		this.projectService.createSingle(this.popupProject)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.getProjects(true);
				},
				(err: any) => {
					this.toastService.error("Could not add project. Please check the details are valid and this project does not already exist.");
					console.log(err);
				}
			);
	}

	addNewProjectPopup() {
		this.popupProject = new Project();
		this.popupProject.clientId = this.item.clientId;
		this.popupTitle = "Add New Project";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewProject(), text: "Add Project" };
	}

	addNewPurchasableItem() {
		this.purchasableItemService.createSingle(this.popupPurchasableItem)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.popupPurchasableItem = new PurchasableItem();
					this.getPurchasableItems();
				},
				(err: any) => console.log(err)
			);
	}

	addNewPurchasableItemPopup() {
		this.popupTitle = "Add New Purchasable Item";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewPurchasableItem(), text: "Add Item" };
	}

	addNewRelationshipChild() {
		this.popupRelationship.masterPartId = this.item.id;
		
		this.partRelationshipService.createSingle(this.popupRelationship)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.popupRelationship = new PartRelationship();
					this.getMasterParts(this.item.id);
					this.getSubParts(this.item.id);
				},
				(err: any) => console.log(err)
			);

		this.closePopup();
	}

	addNewRelationshipChildPopup() {
		this.popupRelationship = new PartRelationship();
		this.popupTitle = "Add New Child Relationship";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewRelationshipChild(), text: "Add Relationship" };
	}

	addNewRelationshipMaster() {
		this.popupRelationship.childPartId = this.item.id;
		
		this.partRelationshipService.createSingle(this.popupRelationship)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.popupRelationship = new PartRelationship();
					this.getMasterParts(this.item.id);
					this.getSubParts(this.item.id);
				},
				(err: any) => console.log(err)
			);

		this.closePopup();
	}

	addNewRelationshipMasterPopup() {
		this.popupRelationship = new PartRelationship();
		this.popupTitle = "Add New Master Relationship";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewRelationshipMaster(), text: "Add Relationship" };
	}

	addNewSupplier() {
		this.supplierService.createSingle(this.popupSupplier)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.getSuppliers();
				},
				(err: any) => {
					this.toastService.error("Could not add supplier. Please check the details are valid and this supplier does not already exist.");
					console.log(err);
				}
			);
	}

	addNewSupplierPopup() {
		this.popupSupplier = new Supplier();
		this.popupTitle = "Add New Supplier";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewSupplier(), text: "Add Supplier" };
	}

	addNewSupportingDocument() {
		if (this.popupSupportingDocument === null || this.popupSupportingDocument === undefined || this.popupSupportingDocument.fileName === "") {
			alert("Please upload a document");
			return;
		}

		if (this.supportingDocuments.length > 0) {
			const previousVersion = Math.max(...this.supportingDocuments.map(o => o.version));
			this.popupSupportingDocument.version = previousVersion + 1;
		} else {
			this.popupSupportingDocument.version = 1;
		}

		this.supportingDocuments.push(this.popupSupportingDocument);
		this.popupSupportingDocument = new PartFileLink();

		if (this.title === "Create New " + this.itemType) {
			this.createItem();
		} else {
			this.updateItem();
		}
		this.closePopup();
	}

	addNewSupportingDocumentPopup() {
		this.popupSupportingDocument = new PartFileLink();
		this.popupTitle = "Add New Supporting Document";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewSupportingDocument(), text: "Add Document" };
	}

	boolYesNo(cellInfo: any) {
		if (cellInfo.value === true) {
			return "YES";
		}
		else {
			return "NO";
		}
	}

	buildButtons(mode: string) {
		this.screenMode = mode;
		this.headerPrimaryButtons = [];
		this.headerSecondaryButtons = [];
		this.headerTertiaryButtons = [];

		if (this.item.deleted === true) {			
			this.headerPrimaryButtons = [
				{ method: "closeToDeleted", text: "Close" },
			];
			return;
		}

		if (mode == "edit" && this.editEnabled) {
			this.readOnly = false;
			this.title = "Edit " + this.itemType;
			this.headerPrimaryButtons = [
				{ icon: "fal fa-save", method: "updateItem", text: "Save Changes" },
				{ icon: "fal fa-eye", method: "cancelEditing", text: "View Mode" },
				{ icon: "fal fa-times", method: "close", text: "Close" }
			];
			this.headerSecondaryButtons = [
				{ icon: "fal fa-copy", method: "copyPartRouterPopup", text: "Copy Router" }
			];
			this.headerTertiaryButtons = [
				{ icon: "fal fa-plus", method: "addNewPurchasableItemPopup", text: "Add New Item" },
				{ icon: "fal fa-plus", method: "addNewClientPopup", text: "Add New Client" },
				{ icon: "fal fa-plus", method: "addNewContactPopup", text: "Add New Contact" },
				{ icon: "fal fa-plus", method: "addNewProjectPopup", text: "Add New Project" },
				{ icon: "fal fa-plus", method: "addNewSupplierPopup", text: "Add New Supplier" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.readOnly = false;
			this.allowRouterChanges = true;
			this.headerPrimaryButtons = [
				{ icon: "fal fa-save", method: "createItem", text: "Save" },
				{ icon: "fal fa-times", method: "close", text: "Close" }
			];
			this.headerSecondaryButtons = [
				{ icon: "fal fa-copy", method: "copyPartRouterPopup", text: "Copy Router" }
			];
			this.headerTertiaryButtons = [
				{ icon: "fal fa-plus", method: "addNewPurchasableItemPopup", text: "Add New Item" },
				{ icon: "fal fa-plus", method: "addNewClientPopup", text: "Add New Client" },
				{ icon: "fal fa-plus", method: "addNewContactPopup", text: "Add New Contact" },
				{ icon: "fal fa-plus", method: "addNewProjectPopup", text: "Add New Project" },
				{ icon: "fal fa-plus", method: "addNewSupplierPopup", text: "Add New Supplier" }
			];
		} else if (mode == "view") {
			this.readOnly = true;
			this.allowRouterChanges = false;
			this.title = "View " + this.itemType;
			this.headerPrimaryButtons = [
				{ icon: "fal fa-pencil", method: "edit", text: "Edit" },
				{ icon: "fal fa-times", method: "close", text: "Close" }
			];
			this.headerSecondaryButtons = [
				{ icon: "fal fa-file-contract", method: "addNewOutsideProcessContractPopup", text: "Add New Outside Process Contract" },
				{ icon: "fal fa-calculator", method: "calculateStatistics", text: "Calculate Statistics" }
			];

			if (this.isEnhancedWorkOrderManagement === true || this.isSuperAdmin === true) {
				this.headerTertiaryButtons.push({ icon: "fal fa-shopping-cart", method: "createSalesOrderPopup", text: "Create Order" });
			}

			const stpFile = this.getLatestStpFile();
			if (stpFile) {
				this.headerSecondaryButtons = this.headerSecondaryButtons.filter((b) => b.method !== "inspectPart");
				this.headerSecondaryButtons.push({ icon: "fal fa-cube", method: "inspectPart", text: "Inspect Part" });
			}
		}
	}

	buildScheduleAgenda() {
		const groups: { entries: PartScheduleEntry[]; label: string }[] = [];
		const entries = this.partSchedule ? this.partSchedule.entries : [];

		entries.forEach((entry) => {
			const label = new Date(entry.date).toLocaleDateString("en-GB", { month: "long", year: "numeric" });
			let group = groups.length > 0 ? groups[groups.length - 1] : null;
			if (group === null || group.label !== label) {
				group = { entries: [], label };
				groups.push(group);
			}
			group.entries.push(entry);
		});
		this.scheduleAgenda = groups;
	}
	// Indexes the schedule by date, finds the busiest day (for timeline bar scaling), and lands the month
	// view on the first month that actually has demand.
	buildScheduleData() {
		this.scheduleMap = {};
		this.scheduleMax = 0;
		const entries = this.partSchedule ? this.partSchedule.entries : [];

		entries.forEach((entry) => {
			this.scheduleMap[this.scheduleDateKey(new Date(entry.date))] = entry;
			if (entry.totalQuantity > this.scheduleMax) { this.scheduleMax = entry.totalQuantity; }
		});

		const anchor = entries.length > 0 ? new Date(entries[0].date) : new Date();
		this.scheduleMonth = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
		this.buildScheduleMonth();
		this.buildScheduleAgenda();
	}
	// A 6-week Monday-first grid for scheduleMonth, each cell carrying its demand entry (if any).
	buildScheduleMonth() {
		const first = new Date(this.scheduleMonth.getFullYear(), this.scheduleMonth.getMonth(), 1);
		const cursor = new Date(first);
		cursor.setDate(cursor.getDate() - ((cursor.getDay() + 6) % 7));

		const weeks: { date: Date; entry: PartScheduleEntry | null; inMonth: boolean }[][] = [];
		for (let w = 0; w < 6; w++) {
			const week: { date: Date; entry: PartScheduleEntry | null; inMonth: boolean }[] = [];
			for (let d = 0; d < 7; d++) {
				week.push({
					date: new Date(cursor),
					entry: this.scheduleMap[this.scheduleDateKey(cursor)] || null,
					inMonth: cursor.getMonth() === first.getMonth()
				});
				cursor.setDate(cursor.getDate() + 1);
			}
			weeks.push(week);
		}
		this.scheduleWeeks = weeks;
	}
	
	calculateStatistics() {
		if (confirm("Are you sure you wish to calculate statistics? Please note this may produce odd results depending on whether accurate information has been entered into the router and ops audits.") === false) {
			return;
		}
		this.itemService.calculateStatistics(this.item.id)
			.subscribe(
				() => {
					this.getItem(this.item.id, this.screenMode, false);
					this.toastService.success("Successfully Calculated Statistics");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.router.navigate([`/${this.returnUrl}/${this.itemId}`])
			.then(() => {
				window.location.reload();
			});
	}

	changeScheduleMonth(offset: number) {
		this.scheduleMonth = new Date(this.scheduleMonth.getFullYear(), this.scheduleMonth.getMonth() + offset, 1);
		this.buildScheduleMonth();
	}

	changeWorkOrderQuantity() {								
		this.workOrderService.changeQuantity(this.popupChangeWorkOrderQuantity.workOrderId, this.popupChangeWorkOrderQuantity.quantity).subscribe(
			() => {
				this.toastService.success("Successfully Updated Work Order");
				this.getWorkOrders(this.item.id);
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			}
		);
		this.closePopup();
	}

	changeWorkOrderQuantityPopup(e: any) {
		this.popupChangeWorkOrderQuantity = new ChangeWorkOrderQuantity();
		this.popupChangeWorkOrderQuantity.workOrderId = e.row.data.id;
		this.popupChangeWorkOrderQuantity.quantity = e.row.data.quantity;
		this.popupTitle = "Change Work Order Quantity";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.changeWorkOrderQuantity(), text: "Change Quantity" };
	}

	close() {
		if (this.screenMode === "view" || confirm("Are you sure you wish to leave the page? Unsaved changes will be discarded.") == true) {
			this.router.navigate([`/${this.returnUrl}/`]);
		}
	}

	closePopup() {
		this.popupVisible = false;
		this.popupClient = new Client();
	}

	closeToDeleted() {
		this.router.navigate([`/${this.returnUrl}/deleted`]);
	}

	copyPartRouter() {
		const partToCopyFrom = this.parts.filter((p) => p.id === this.popupPartToCopyRouterFrom.id)[0];
		this.processRouters = JSON.parse(partToCopyFrom.router);
		this.closePopup();
	}

	copyPartRouterPopup() {
		this.popupPartToCopyRouterFrom = new Part();
		this.popupTitle = "Copy Router From Part";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.copyPartRouter(), text: "Copy Router" };
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.prepareItemForSaving();

		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated " + this.itemType);
					this.item = new Part();
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	createSalesOrder() {
		if (confirm("Are you sure you wish to create a Sales Order with these details?") === false) {
			return;
		}
		this.salesOrderService.createFromPart(this.popupCreateSalesOrderFromPart)
			.subscribe(
				(res: any) => {
					this.popupVisible = false;
					this.popupCreateSalesOrderFromPart = new CreateSalesOrderFromPart();

					const closingResults = res.response;
					this.router.navigate([`/admin/salesOrders/${closingResults.lookupId}_edit`]);
				},
				(err: any) => {
					this.toastService.error("Could not create sales order. Please double check the details.");
					console.log(err);
				}
			);
	}

	createSalesOrderPopup() {
		this.popupCreateSalesOrderFromPart = new CreateSalesOrderFromPart();
		this.popupCreateSalesOrderFromPart.clientId = this.item.clientId;
		this.popupCreateSalesOrderFromPart.clientContactId = this.item.clientContactId !== undefined ? this.item.clientContactId : 0;
		this.popupCreateSalesOrderFromPart.partId = this.item.id;
		this.popupCreateSalesOrderFromPart.projectId = this.item.projectId;
		this.popupCreateSalesOrderFromPart.quantity = 1;
		this.popupTitle = "Create Sales Order";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.createSalesOrder(), text: "Create Sales Order" };
	}

	deleteCadFileLink(e: any) {
		const index = this.cadFiles.findIndex(d => d.version === e.row.data.version);
		this.cadFiles.splice(index, 1);

		return false;
	}

	deletePartRelationship(e: any) {
		if (confirm("Are you sure you want to delete this relationship? This will not affect existing work orders.") == false) {
			return;
		}

		this.partRelationshipService.deleteSingleById(e.row.data.id)
			.subscribe(
				() => {
					this.toastService.success("Relationship deleted!");
					this.getMasterParts(this.item.id);
					this.getSubParts(this.item.id);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
		return false;
	}

	deleteProductionToolPart(e: any) {
		if (confirm("Are you sure you want to remove this production tool? This will not affect existing work orders.") == false) {
			return;
		}

		this.productionToolPartService.deleteSingleById(e.row.data.id)
			.subscribe(
				() => {
					this.toastService.success("Relationship removed!");
					this.getProductionToolParts();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
		return false;
	}

	deleteSupportingDocumentLink(e: any) {
		const index = this.supportingDocuments.findIndex(d => d.version === e.row.data.version);
		this.supportingDocuments.splice(index, 1);

		return false;
	}

	deleteTechnicalDrawingLink(e: any) {
		const index = this.technicalDrawings.findIndex(d => d.version === e.row.data.version);
		this.technicalDrawings.splice(index, 1);

		return false;
	}

	displayMachineInDropdown(e: any) { 
		return e === null || e === undefined ? "" : (e.cellNumber === null || e.cellNumber === undefined ? "???" : e.cellNumber) + " - " + e.name;
	}

	private downloadBlob(response: any, fileName: string) {
		const downloadLink = document.createElement("a");
		downloadLink.href = window.URL.createObjectURL(new Blob([response], { type: response.type }));
		downloadLink.setAttribute("download", fileName);
		document.body.appendChild(downloadLink);
		downloadLink.click();
		downloadLink.remove();
	}

	downloadDeliveryNote(e: any) {
		const id = e.row.data.deliveryNoteId;
		this.deliveryNoteService.generateAndPreviewPdf(id).subscribe(
			(response: any) => this.downloadBlob(response, "Delivery_Note_" + id + ".pdf")
		);
	}

	downloadFileLink(e: any) {
		const lookupId = Guid.parse(e.row.data.lookupId);
		this.fileService.downloadFile(lookupId).subscribe(
			(response: any) =>{
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
				downloadLink.setAttribute("download", e.row.data.fileName);
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
		return false;
	}

	downloadInvoice(e: any) {
		const id = e.row.data.invoiceId;
		this.invoiceService.generateAndPreviewPdf(id).subscribe(
			(response: any) => this.downloadBlob(response, "INV" + id + ".pdf")
		);
	}
	edit() {
		this.router.navigate([`/${this.returnUrl}/${this.itemId}_edit`])
			.then(() => {
				window.location.reload();
			});
	}

	editOutsideProcessContractPopup(e: any) {
		this.outsideProcessContractService.getSingleById(e.row.data.id).subscribe(
			(res: any) => {
				this.popupVisible = true;
				this.popupAddButtonOptions = { onClick: () => this.updateOutsideProcessContract(), text: "Save Changes" };
				this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
				this.popupOutsideProcessContract = res.response;
				this.popupTitle = "Edit Outside Process";
			},
			(err) => {
				console.log(err);
				this.toastService.error("Could not load this contract.");
			}
		);
	}

	editPartRelationship() {
		this.partRelationshipService.updateSingleById(this.popupRelationship.id, this.popupRelationship)
			.subscribe(
				() => {
					this.toastService.success("Relationship updated!");
					this.getMasterParts(this.item.id);
					this.getSubParts(this.item.id);
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
		return false;
	}

	editPartRelationshipChildPopup(e: any) {
		const partRelationshipId = e.row.data.id;
		this.popupRelationship = this.subParts.filter(p => p.id == partRelationshipId)[0];
		this.popupTitle = "Edit Child Relationship";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.editPartRelationship(), text: "Save Changes" };
		return false;
	}

	editPartRelationshipMasterPopup(e: any) {
		const partRelationshipId = e.row.data.id;
		this.popupRelationship = this.masterParts.filter(p => p.id == partRelationshipId)[0];
		this.popupTitle = "Edit Master Relationship";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.editPartRelationship(), text: "Save Changes" };
		return false;
	}

	editProductionToolPart() {
		this.productionToolPartService.updateSingleById(this.popupProductionToolPart.id, this.popupProductionToolPart)
			.subscribe(
				() => {
					this.toastService.success("Tool updated!");
					this.getProductionToolParts();
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
		return false;
	}

	editProductionToolPartPopup(e: any) {
		const productionToolPartId = e.row.data.id;
		this.popupProductionToolPart = this.productionToolParts.filter(p => p.id == productionToolPartId)[0];
		this.popupTitle = "Edit Tool";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.editProductionToolPart(), text: "Save Changes" };
		return false;
	}

	editWorkOrder(e: any) {
		this.router.navigate([`admin/workOrders/${e.row.data.id}_edit`]);
	}

	formDataChanged(args: any) {
		switch (args.dataField) {
			case "clientId":
				this.getContacts(args.value);
				this.getOutsourcedSpecifications(args.value);
				break;
			case "clientContactId":
				this.getContact(args.value);
				break;
		}
	}

	generateAndDownloadWorkOrderMasterLabelPDF(e: any) {
		this.workOrderService.generateAndDownloadMasterLabelPdf(e.row.data.id).subscribe(
			(response: any) => {
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
				downloadLink.setAttribute("download", "Work_Order_Master_Label_" + this.item.id + ".pdf");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			},
			(err) => {
				console.log(err);
				this.toastService.error("Something Went Wrong!");
			},
		);
	}

	getClients(setNewestClient = false) {
		this.clientService.getAll()
			.subscribe(
				(res: any) => {
					this.clients = res.response.items;

					if (setNewestClient) {
						this.item.clientId = this.clients[this.clients.length - 1].id;
					}

					this.clients.sort((a,b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getContact(contactId: number) {
		this.clientContactService.getSingleById(contactId)
			.subscribe(
				(res: any) => {
					this.contact = res.response;
					this.item.clientContactId = contactId;
				},
				(err) => console.log(err)
			);
	}

	getContacts(clientId: number, setNewestContact = false)	{
		this.clientContactService.getContactByParentId(clientId)
			.subscribe(
				(res: any) => {
					this.contacts = res.response;

					if (setNewestContact) {
						this.getContact(this.contacts[this.contacts.length - 1].id);
					} else if (this.contacts.some(c => c.id === this.item.clientContactId)) {
						// do nothing, the contact is present
					}
					else
					{
						this.getContact(this.contacts[0].id);
					}

					this.contacts.sort((a,b) => a.contactName.localeCompare(b.contactName));
				},
				(err) => console.log(err)
			);
	}

	// Outbound tab: delivery notes that include this part.
	getDeliveryNotesForPart(itemId: number) {
		this.deliveryNoteService.getForPart(itemId)
			.subscribe(
				(res: any) => {
					this.deliveryNotesForPart = res.response;
				},
				(err) => {
					console.log(err);
				}
			);
	}
	// Outbound tab: invoices that include this part.
	getInvoicesForPart(itemId: number) {
		this.invoiceService.getForPart(itemId)
			.subscribe(
				(res: any) => {
					this.invoicesForPart = res.response;
				},
				(err) => {
					console.log(err);
				}
			);
	}

	getItem(itemId: number, mode: string, hideButtons: boolean) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.cadFiles = JSON.parse(this.item.cadFiles);
					this.consumablesRequired = JSON.parse(this.item.consumablesRequired);
					if (this.consumablesRequired === null || this.consumablesRequired === undefined) {
						this.consumablesRequired = [];
					}
					this.fixingsRequired = JSON.parse(this.item.fixingsRequired);
					if (this.fixingsRequired === null || this.fixingsRequired === undefined) {
						this.fixingsRequired = [];
					}
					this.supportingDocuments = JSON.parse(this.item.supportingDocuments);
					this.technicalDrawings = JSON.parse(this.item.technicalDrawings);
					this.processRouters = JSON.parse(this.item.router);
					this.getContacts(this.item.clientId);
					this.getOpsActionAudits(itemId);
					this.getOutsideProcessContracts(itemId);
					this.getOutsourcedSpecifications(this.item.clientId);
					this.getPurchasableItems();
					this.setPackingImageStyle(this.item.packagingExampleUrl, false);
					this.setPackingImageStyle(this.item.packagingExampleUrlExternal, true);
					this.setTileImageStyle(this.item.tileImageUrl);
					this.getProductionToolParts();
					this.getQuarantinedParts(itemId);
					this.getSubParts(itemId);
					this.getMasterParts(itemId);
					this.getWorkOrderStageSummary(itemId);
					this.getWorkOrders(itemId);
					this.getDeliveryNotesForPart(itemId);
					// Invoicing is restricted to Super Admin, both here and on the API.
					if (this.isSuperAdmin) { this.getInvoicesForPart(itemId); }
					this.getSchedule(itemId);

					if (this.screenMode === "edit" ) {
						if (this.item.linkedPartGroupId !== null && this.item.linkedPartGroupId !== undefined && this.item.linkedPartGroupId > 0) {
							this.allowRouterChanges = false;
						} else {
							this.allowRouterChanges = true;
						}
					}

					if (hideButtons == false) {
						this.buildButtons(mode);
					}
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getLatestStpFile(): PartFileLink | null {
		const stpFiles = this.cadFiles.filter((f) => f.fileName && f.fileName.toLowerCase().match(/\.(stp|step)$/));
		if (stpFiles.length === 0) return null;
		return stpFiles.reduce((a, b) => a.version > b.version ? a : b);
	}

	getMachines() {
		this.machineService.getAll()
			.subscribe(
				(res: any) => {
					this.machines = res.response.items;					
					this.dropDownFirewallMachines = [];
					this.machines.forEach((machine: Machine) => {
						if (machine.department === Department.Firewall) {
							this.dropDownFirewallMachines.push(machine);
						}
					});
				},
				(err) => console.log(err)
			);
	}

	getMasterParts(id: number) {
		this.partRelationshipService.getMasterByChildPart(id)
			.subscribe(
				(res: any) => this.masterParts = res.response,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getOpsActionAudits(partId: number)	{
		this.opsActionAuditService.getByPartId(partId)
			.subscribe(
				(res: any) => {
					this.opsActionAudits = res.response;
				},
				(err) => console.log(err)
			);
	}

	getOutsideProcessContracts(partId: number)	{
		this.outsideProcessContractService.getByPartId(partId)
			.subscribe(
				(res: any) => {
					this.outsideProcessContracts = res.response;
				},
				(err) => console.log(err)
			);
	}

	getOutsourcedSpecifications(clientId: number)	{
		this.outsourcedSpecificationService.getByClientId(clientId)
			.subscribe(
				(res: any) => {
					this.outsourcedSpecifications = res.response;

					this.outsourcedSpecifications.sort((a,b) => a.specification.localeCompare(b.specification));
				},
				(err) => console.log(err)
			);
	}

	getPackaging() {
		this.packagingService.getAll()
			.subscribe(
				(res: any) => {
					this.packaging = res.response.items;

					this.packaging.sort((a,b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getParts() {
		this.itemService.getAll()
			.subscribe(
				(res: any) => this.parts = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getPaymentTerms() {
		this.paymentTermsService.getAll()
			.subscribe(
				(res: any) => {
					this.paymentTerms = res.response.items;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
	
	getPeople() {
		this.userProfileService.getActiveUsers()
			.subscribe(
				(res: any) =>  {
					this.people = res.response;
					this.people.sort((a,b) => a.fullName.localeCompare(b.fullName));
				},
				(err) => console.log(err)
			);
	}

	getProcessMachines(processId: number) {
		this.processMachineService.forProcess(processId)
			.subscribe(
				(res: any) => {
					const results = res.response;
					console.log(results);
					this.dropDownMachines = [];

					results.forEach((result: any) => {
						this.dropDownMachines.push(result.machine);
					});
				},
				(err) => console.log(err)
			);
	}

	getProcesses() {
		this.processService.getAll()
			.subscribe(
				(res: any) => {
					this.processes = res.response.items;

					this.processes.sort((a,b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getProductionToolParts() {
		this.productionToolPartService.forPartId(this.item.id)
			.subscribe(
				(res: any) => {
					this.productionToolParts = res.response;
				},
				(err) => console.log(err)
			);
	}

	getProductionTools() {
		this.productionToolService.getAll()
			.subscribe(
				(res: any) => {
					this.productionTools = res.response.items;

					this.productionTools.sort((a,b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	getProjects(setNewestProject = false) {
		this.projectService.getAll()
			.subscribe(
				(res: any) => {
					this.projects = res.response.items;
					if (setNewestProject) {
						this.item.projectId = this.projects[this.projects.length - 1].id;
					}

					this.projects.sort((a,b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}
	
	getPurchasableItems() {
		this.purchasableItemService.getAll()
			.subscribe(
				(res: any) => {
					this.purchasableItems = res.response.items;
					this.purchasableItems.sort((a,b) => a.name.localeCompare(b.name));

					this.consumablePurchasableItems = this.purchasableItems.filter((pi) => pi.purchaseType === PurchaseTypeEnum.Consumables);
					this.fixingPurchasableItems = this.purchasableItems.filter((pi) => pi.purchaseType === PurchaseTypeEnum.Fixings);
					this.materialPurchasableItems = this.purchasableItems.filter((pi) => pi.purchaseType === PurchaseTypeEnum.Material);
				},
				(err) => console.log(err)
			);
	}

	getQuarantinedParts(id: number) {
		this.quarantinedPartService.getByPartId(id)
			.subscribe(
				(res: any) => {
					this.quarantinedParts = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	// Outbound tab: forward EDI demand (firm + forecast) for the Schedule calendar.
	getSchedule(itemId: number) {
		this.ediOrderService.getScheduleForPart(itemId)
			.subscribe(
				(res: any) => {
					this.partSchedule = res.response;
					this.buildScheduleData();
				},
				(err) => {
					console.log(err);
				}
			);
	}
	getSubParts(id: number) {
		this.partRelationshipService.getChildByMasterParts(id)
			.subscribe(
				(res: any) => {
					this.subParts = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getSuppliers() {
		this.supplierService.getAll()
			.subscribe(
				(res: any) => {
					this.suppliers = res.response.items;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getWorkOrderStageSummary(itemId: number) {
		this.workOrderService.getStageSummaryForPart(itemId)
			.subscribe(
				(res: any) => {
					this.workOrderStageSummary = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	getWorkOrders(itemId: number) {
		this.workOrderService.getForPart(itemId)
			.subscribe(
				(res: any) => {
					this.workOrders = res.response;
					this.workOrders.forEach((workOrder: any) => {
						if (workOrder.allocations !== null && workOrder.allocations !== undefined && workOrder.allocations.length > 0) {
							const allocationQuantities = workOrder.allocations.map((allocation: any) => allocation.quantity);
							workOrder.totalAllocated = allocationQuantities.reduce((a: number, b: number) => a + b);
						}
					});
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}


	
	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	inspectPart() {
		const stpFile = this.getLatestStpFile();
		if (!stpFile) return;
		this.inspectPartVisible = true;
		this.fileService.downloadFile(stpFile.lookupId as any)
			.subscribe(
				(response: any) => {
					const reader = new FileReader();
					reader.onload = () => {
						const buffer = reader.result as ArrayBuffer;
						this.renderStpModel(buffer);
					};
					reader.readAsArrayBuffer(response);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Failed to load CAD file");
					this.inspectPartVisible = false;
				}
			);
	}
	
	isResolveAvailableForRow(e: any) {
		return e.row.data.quarantineResolved === false && (this.isProductionManagement || this.isQualityManagement || this.isSuperAdmin);
	}

	// Outbound tab — delivery notes. openDeliveryNote is also called from the invoice grid's
	// linked-delivery-note cell, viewDeliveryNote from the delivery-note grid's row button.
	openDeliveryNote(id: number) {
		this.router.navigate([`admin/deliveryNotes/${id}`]);
	}
	// Outbound tab — invoices. openInvoice is also called from the delivery-note grid's linked-invoice cell.
	openInvoice(id: number) {
		this.router.navigate([`admin/invoices/${id}`]);
	}
	popupPurchasableItemFormDataChanged(args: any) {
		switch (args.dataField) {
			case "purchaseType":
				if (this.popupPurchasableItem.purchaseType !== PurchaseTypeEnum.Material && this.popupPurchasableItem.purchaseType !== PurchaseTypeEnum.ToolingBillet) {
					this.popupPurchasableItem.materialType = MaterialType.NotApplicable;
				}
				this.popupPurchasableItem.weightConstant = densityForMaterialType(this.popupPurchasableItem.materialType);
				break;
			case "materialType":
				// Density (weightConstant) is derived from the material type.
				this.popupPurchasableItem.weightConstant = densityForMaterialType(this.popupPurchasableItem.materialType);
				break;
		}
	}

	prepareItemForSaving() {
		if (this.item.clientContactId === 0) { this.item.clientContactId = undefined; }
		if (this.item.engineeringContactId === 0) { this.item.engineeringContactId = undefined; }
		if (this.item.packagingExternalId === 0) { this.item.packagingExternalId = undefined; }
		if (this.item.materialId === 0) { this.item.materialId = undefined; }
		if (this.item.packagingId === 0) { this.item.packagingId = undefined; }
		if (this.item.projectManagerId === 0) { this.item.projectManagerId = undefined; }

		this.item.cadFiles = JSON.stringify(this.cadFiles);
		this.item.consumablesRequired = JSON.stringify(this.consumablesRequired);
		this.item.fixingsRequired = JSON.stringify(this.fixingsRequired);
		this.item.router = JSON.stringify(this.processRouters);
		this.item.supportingDocuments = JSON.stringify(this.supportingDocuments);
		this.item.technicalDrawings = JSON.stringify(this.technicalDrawings);
	}

	renderStpModel(buffer: ArrayBuffer) {
		const container = document.getElementById("stp-viewer-container");
		if (!container) return;
		container.innerHTML = "<div style='display:flex;align-items:center;justify-content:center;height:100%;color:#9ca3af;'>Loading 3D model...</div>";

		const loadOcct = (): Promise<any> => {
			return new Promise((resolve) => {
				if ((window as any).occtimportjs) {
					(window as any).occtimportjs().then(resolve);
					return;
				}
				const script = document.createElement("script");
				script.src = "https://cdn.jsdelivr.net/npm/occt-import-js@0.0.23/dist/occt-import-js.js";
				script.onload = () => (window as any).occtimportjs().then(resolve);
				document.head.appendChild(script);
			});
		};

		loadOcct().then((oc: any) => {
			container.innerHTML = "";
			const fileBuffer = new Uint8Array(buffer);
			const result = oc.ReadStepFile(fileBuffer, null);

			const scene = new THREE.Scene();
			scene.background = new THREE.Color(0xf3f4f6);
			this.stpScene = scene;
			this.stpMeshes = [];
			this.stpOriginalColours = [];
			this.stpWireframe = false;
			this.stpColourMode = 0;
			this.stpBackgroundIndex = 0;

			scene.add(new THREE.AmbientLight(0xffffff, 0.6));
			const dirLight = new THREE.DirectionalLight(0xffffff, 0.8);
			dirLight.position.set(1, 1, 1);
			scene.add(dirLight);
			const dirLight2 = new THREE.DirectionalLight(0xffffff, 0.4);
			dirLight2.position.set(-1, -1, -0.5);
			scene.add(dirLight2);

			let totalSurfaceArea = 0;
			let totalVolume = 0;

			for (const resultMesh of result.meshes) {
				const positions = new Float32Array(resultMesh.attributes.position.array);
				const indices = new Uint32Array(resultMesh.index.array);
				const geometry = new THREE.BufferGeometry();
				geometry.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
				if (resultMesh.attributes.normal) {
					geometry.setAttribute("normal", new THREE.Float32BufferAttribute(new Float32Array(resultMesh.attributes.normal.array), 3));
				}
				geometry.setIndex(new THREE.BufferAttribute(indices, 1));

				for (let t = 0; t < indices.length; t += 3) {
					const i0 = indices[t] * 3; const i1 = indices[t + 1] * 3; const i2 = indices[t + 2] * 3;
					const ax = positions[i0]; const ay = positions[i0 + 1]; const az = positions[i0 + 2];
					const bx = positions[i1]; const by = positions[i1 + 1]; const bz = positions[i1 + 2];
					const cx = positions[i2]; const cy = positions[i2 + 1]; const cz = positions[i2 + 2];
					const crossX = (by - ay) * (cz - az) - (bz - az) * (cy - ay);
					const crossY = (bz - az) * (cx - ax) - (bx - ax) * (cz - az);
					const crossZ = (bx - ax) * (cy - ay) - (by - ay) * (cx - ax);
					const area = Math.sqrt(crossX * crossX + crossY * crossY + crossZ * crossZ) * 0.5;
					totalSurfaceArea += area;
					totalVolume += (ax * (by * cz - bz * cy) + bx * (cy * az - cz * ay) + cx * (ay * bz - az * by)) / 6.0;
				}

				let color = 0x8899aa;
				if (resultMesh.color) {
					color = new THREE.Color(resultMesh.color[0], resultMesh.color[1], resultMesh.color[2]).getHex();
				}
				const material = new THREE.MeshPhongMaterial({ color, side: THREE.DoubleSide });
				const mesh = new THREE.Mesh(geometry, material);
				scene.add(mesh);
				this.stpMeshes.push(mesh);
				this.stpOriginalColours.push(color);

				geometry.computeBoundingBox();
				this.stpMeshCenters.push(geometry.boundingBox ? geometry.boundingBox.getCenter(new THREE.Vector3()) : new THREE.Vector3());
			}

			this.stpSurfaceArea = `${totalSurfaceArea.toFixed(1)} mm²`;
			this.stpVolume = `${Math.abs(totalVolume).toFixed(1)} mm³`;

			const box = new THREE.Box3().setFromObject(scene);
			const center = box.getCenter(new THREE.Vector3());
			const dims = box.getSize(new THREE.Vector3());
			const size = dims.length();
			this.stpDimensions = `${dims.x.toFixed(1)} x ${dims.y.toFixed(1)} x ${dims.z.toFixed(1)} mm`;

			const camera = new THREE.PerspectiveCamera(45, container.clientWidth / container.clientHeight, size / 1000, size * 10);
			camera.position.copy(center).add(new THREE.Vector3(size * 0.8, size * 0.6, size * 0.8));
			camera.lookAt(center);
			this.stpCamera = camera;
			this.stpInitialCameraPos = camera.position.clone();
			this.stpInitialTarget = center.clone();

			const renderer = new THREE.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true });
			renderer.setSize(container.clientWidth, container.clientHeight);
			renderer.setPixelRatio(window.devicePixelRatio);
			container.appendChild(renderer.domElement);
			this.stpRenderer = renderer;

			const controls = new OrbitControls(camera, renderer.domElement);
			controls.target.copy(center);
			controls.update();
			this.stpControls = controls;

			const raycaster = new THREE.Raycaster();
			const mouse = new THREE.Vector2();
			const measureMarkers: any[] = [];
			renderer.domElement.addEventListener("click", (event: MouseEvent) => {
				if (!this.stpMeasureMode) return;
				const rect = renderer.domElement.getBoundingClientRect();
				mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
				mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
				raycaster.setFromCamera(mouse, camera);
				const intersects = raycaster.intersectObjects(this.stpMeshes);
				if (intersects.length > 0) {
					const point = intersects[0].point;
					const marker = new THREE.Mesh(
						new THREE.SphereGeometry(size * 0.008, 16, 16),
						new THREE.MeshBasicMaterial({ color: 0xff0000 })
					);
					marker.position.copy(point);
					scene.add(marker);
					measureMarkers.push(marker);

					if (!this.stpMeasurePoint1) {
						this.stpMeasurePoint1 = point.clone();
						this.stpMeasureResult = "Click second point...";
					} else {
						const dist = this.stpMeasurePoint1.distanceTo(point);
						this.stpMeasureResult = `Distance: ${dist.toFixed(2)} mm`;
						this.stpMeasurePoint1 = null;
						setTimeout(() => {
							measureMarkers.forEach((m) => scene.remove(m));
							measureMarkers.length = 0;
						}, 5000);
					}
				}
			});

			const animate = () => {
				if (!this.inspectPartVisible) {
					renderer.dispose();
					return;
				}
				requestAnimationFrame(animate);
				controls.update();
				renderer.render(scene, camera);
			};
			animate();
		});
	}
	
	resolveQuarantine() {
		this.quarantinedPartService.resolve(this.popupResolveQuarantine)
			.subscribe(
				() => {
					this.getQuarantinedParts(this.item.id);
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	resolveQuarantinePopup(e: any) {
		this.popupResolveQuarantine = new ResolveQuarantineDto();
		this.popupResolveQuarantine.quarantinedPartId = e.row.data.id;
		this.popupAmountQuarantined = e.row.data.amountQuarantined;
		this.popupAddButtonOptions = { onClick: () => this.resolveQuarantine(), text: "Resolve" };
		this.popupTitle = "Resolve Quarantine";
		this.popupVisible = true;
	}

	scheduleDateKey(date: Date): string {
		const month = ("0" + (date.getMonth() + 1)).slice(-2);
		const day = ("0" + date.getDate()).slice(-2);
		return `${date.getFullYear()}-${month}-${day}`;
	}
	setPackingImageStyle(imageUrl: string, isExternal: boolean) {
		if (isExternal) {
			this.packagingImageStyleExternal = `background-image: url("${imageUrl}")`;
		} else {
			this.packagingImageStyle = `background-image: url("${imageUrl}")`;
		}		
	}

	setScheduleView(view: string) {
		this.scheduleView = view;
	}
	setTileImageStyle(imageUrl: string) {
		this.tileImageStyle = `background-image: url("${imageUrl}")`;
	}

	stageToOP(cellInfo: any) {
		if (cellInfo.value === null || cellInfo.value === undefined) {
			return "None";
		}
		return "OP" + cellInfo.value + "0";
	}

	stpCycleBackground() {
		const backgrounds = [0xf3f4f6, 0xffffff, 0x1f2937, 0x000000];
		this.stpBackgroundIndex = (this.stpBackgroundIndex + 1) % backgrounds.length;
		if (this.stpScene) this.stpScene.background = new THREE.Color(backgrounds[this.stpBackgroundIndex]);
	}

	stpCycleColourMode() {
		this.stpColourMode = (this.stpColourMode + 1) % 3;
		this.stpMeshes.forEach((mesh: any, i: number) => {
			if (this.stpColourMode === 0) {
				mesh.material.color.setHex(this.stpOriginalColours[i]);
				mesh.material.opacity = 1;
				mesh.material.transparent = false;
			} else if (this.stpColourMode === 1) {
				mesh.material.color.setHex(0x4488cc);
				mesh.material.opacity = 1;
				mesh.material.transparent = false;
			} else {
				mesh.material.color.setHex(0x4488cc);
				mesh.material.opacity = 0.3;
				mesh.material.transparent = true;
			}
		});
	}

	stpResetCamera() {
		if (this.stpCamera && this.stpControls && this.stpInitialCameraPos && this.stpInitialTarget) {
			this.stpCamera.position.copy(this.stpInitialCameraPos);
			this.stpControls.target.copy(this.stpInitialTarget);
			this.stpControls.update();
		}
	}

	stpScreenshot() {
		if (!this.stpRenderer) return;
		const link = document.createElement("a");
		link.download = `${this.item.partNumber || "part"}-3d.png`;
		link.href = this.stpRenderer.domElement.toDataURL("image/png");
		link.click();
	}

	stpToggleExploded() {
		this.stpExploded = !this.stpExploded;
		if (this.stpMeshes.length <= 1) return;
		const sceneBox = new THREE.Box3().setFromObject(this.stpScene);
		const sceneCenter = sceneBox.getCenter(new THREE.Vector3());
		const explodeScale = sceneBox.getSize(new THREE.Vector3()).length() * 0.3;

		this.stpMeshes.forEach((mesh: any, i: number) => {
			if (this.stpExploded) {
				const meshCenter = this.stpMeshCenters[i];
				const direction = new THREE.Vector3().subVectors(meshCenter, sceneCenter).normalize();
				mesh.position.copy(direction.multiplyScalar(explodeScale));
			} else {
				mesh.position.set(0, 0, 0);
			}
		});
	}

	stpToggleMeasureMode() {
		this.stpMeasureMode = !this.stpMeasureMode;
		this.stpMeasurePoint1 = null;
		this.stpMeasureResult = this.stpMeasureMode ? "Click first point..." : "";
		if (this.stpControls) {
			this.stpControls.enabled = !this.stpMeasureMode;
		}
	}

	stpToggleWireframe() {
		this.stpWireframe = !this.stpWireframe;
		this.stpMeshes.forEach((mesh: any) => {
			mesh.material.wireframe = this.stpWireframe;
		});
	}

	toggleSchedule() {
		this.scheduleExpanded = !this.scheduleExpanded;
	}
	updateItem() {
		this.prepareItemForSaving();

		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	updateOutsideProcessContract() {
		this.outsideProcessContractService.updateSingleById(this.popupOutsideProcessContract.id, this.popupOutsideProcessContract)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated Contract");
					this.closePopup();
					this.getOutsideProcessContracts(this.item.id);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Please ensure all fields are entered and there isn't another active contract for this stage.");
				}
			);
	}

	updateRouterNumbers() {
		for (let i = 0; i < this.processRouters.length; i++) {
			this.processRouters[i].stage = i + 1;
		}
	}

	updateRouterOEECalculations() {		
		this.processRouters.forEach(line => {
			if (line.actualCycleTime != undefined && line.actualCycleTime > 0 && line.estimatedCycleTime != undefined && line.estimatedCycleTime > 0) {
				line.actualOEE = 100 * line.estimatedCycleTime / line.actualCycleTime;
			} else {
				line.actualOEE = undefined;
			}
		});
	}

	updateRouterOrder(e: any) {
		const visibleRows = e.component.getVisibleRows();
		const toIndex = this.processRouters.indexOf(visibleRows[e.toIndex].data);
		const fromIndex = this.processRouters.indexOf(e.itemData);
	
		this.processRouters.splice(fromIndex, 1);
		this.processRouters.splice(toIndex, 0, e.itemData);

		this.updateRouterNumbers();
	}

	uploadCadFile(file: File) {
		const containerName = "partfiles";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		// Add Mime Type key when mime types are decided upon...
		// uploadData.append("mimeTypeKey", "CADFileMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					const newCadFile = new PartFileLink();
					newCadFile.lookupId = res.response[0].lookupId;
					newCadFile.fileName = res.response[0].name;
					if (this.cadFiles.length > 0) {
						const previousVersion = Math.max(...this.cadFiles.map(o => o.version));
						newCadFile.version = previousVersion + 1;
					} else {
						newCadFile.version = 1;
					}

					this.cadFiles.push(newCadFile);
				},
				(err) => {
					console.log(err);
					this.toastService.error("CAD File Upload Failed - Please ensure you are uploading a valid CAD file");
				}
			);
	}

	uploadPackingImage(file: File) {
		const containerName = "images";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		uploadData.append("mimeTypeKey", "ImageMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.item.packagingExampleUrl = `${environment.server.storageUrl}/${containerName}/${res.response[0].location}`;
					this.setPackingImageStyle(this.item.packagingExampleUrl, false);
					this.toastService.success("Image uploaded - Click Save to confirm change");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Image Upload Failed - Please ensure you are uploading a valid image file");
				}
			);
	}

	uploadPackingImageExternal(file: File) {
		const containerName = "images";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		uploadData.append("mimeTypeKey", "ImageMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.item.packagingExampleUrlExternal = `${environment.server.storageUrl}/${containerName}/${res.response[0].location}`;
					this.setPackingImageStyle(this.item.packagingExampleUrlExternal, true);
					this.toastService.success("Image uploaded - Click Save to confirm change");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Image Upload Failed - Please ensure you are uploading a valid image file");
				}
			);
	}

	uploadSupportingDocument(file: File) {
		const containerName = "partfiles";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		// Add Mime Type key when mime types are decided upon...
		// uploadData.append("mimeTypeKey", "CADFileMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.popupSupportingDocument.lookupId = res.response[0].lookupId;
					this.popupSupportingDocument.fileName = res.response[0].name;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Supporting Document Upload Failed - Please ensure you are uploading a valid file");
				}
			);
	}

	uploadTechnicalDrawing(file: File) {
		const containerName = "partfiles";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		// Add Mime Type key when mime types are decided upon...
		// uploadData.append("mimeTypeKey", "CADFileMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					const newTechnicalDrawing = new PartFileLink();
					newTechnicalDrawing.lookupId = res.response[0].lookupId;
					newTechnicalDrawing.fileName = res.response[0].name;
					if (this.technicalDrawings.length > 0) {
						const previousVersion = Math.max(...this.cadFiles.map(o => o.version));
						newTechnicalDrawing.version = previousVersion + 1;
					} else {
						newTechnicalDrawing.version = 1;
					}

					this.technicalDrawings.push(newTechnicalDrawing);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Technical Drawing Upload Failed - Please ensure you are uploading a valid file");
				}
			);
	}

	uploadTileImage(file: File) {
		const containerName = "images";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", file);
		uploadData.append("mimeTypeKey", "ImageMimeTypes");
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.item.tileImageUrl = `${environment.server.storageUrl}/${containerName}/${res.response[0].location}`;
					this.setTileImageStyle(this.item.tileImageUrl);
					this.toastService.success("Image uploaded - Click Save to confirm change");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Image Upload Failed - Please ensure you are uploading a valid image file");
				}
			);
	}

	viewDeliveryNote(e: any) {
		this.openDeliveryNote(e.row.data.deliveryNoteId);
	}
	viewInvoice(e: any) {
		this.openInvoice(e.row.data.invoiceId);
	}
	viewMasterPart(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.masterPart.id}`]);
	}

	viewProductionTool(e: any) {
		this.router.navigate([`admin/productionTools/${e.row.data.productionToolId}`]);
	}

	viewSubPart(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.childPart.id}`]);
	}

	viewWorkOrder(e: any) {
		this.router.navigate([`admin/workOrders/${e.row.data.id}`]);
	}







}